"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapApiResult = void 0;
const class_transformer_1 = require("class-transformer");
function mapApiResult(data, models) {
    const mappedData = Object.assign({}, data);
    if (models) {
        const keys = Object.keys(models);
        for (const key of keys) {
            const plain = mappedData[key];
            const model = models[key];
            if (model && plain && !(plain instanceof model)) {
                mappedData[key] = class_transformer_1.plainToClass(model, plain);
            }
        }
    }
    return mappedData;
}
exports.mapApiResult = mapApiResult;
